import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ContentChild,
  HostBinding,
  HostListener,
  Input,
  ViewChild,
} from '@angular/core';

import { FlipCardBackDirective } from './flip-card-back.directive';
import { FlipCardFrontDirective } from './flip-card-front.directive';

@Component({
    selector: 'lui-flip-card',
    templateUrl: './flip-card.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FlipCardComponent {
  private _model = 'flip-card';

  @Input() get flipped(): boolean {
    return this._flipped;
  }
  set flipped(value: boolean) {
    this._flipped = value;
  }
  private _flipped = false;

  @Input() flipOnHover = false;

  @HostBinding('class') modelClass = this._model;

  @HostBinding('class.flip-card-back-visible') get getFlippedClass() {
    return this._flipped;
  }

  @ContentChild(FlipCardFrontDirective)
  front!: FlipCardFrontDirective;

  @ViewChild(FlipCardBackDirective) back!: FlipCardBackDirective;

  @HostListener('mouseenter') onMouseenter() {
    if (this.flipOnHover) {
      this._flipped = true;
      this.cd.markForCheck();
    }
  }

  @HostListener('mouseleave') onMouseleave() {
    if (this.flipOnHover) {
      this._flipped = false;
      this.cd.markForCheck();
    }
  }

  constructor(private cd: ChangeDetectorRef) {}

  flip(): void {
    this._flipped = !this._flipped;
    this.cd.markForCheck();
  }
}
